import { useNavigate } from "react-router-dom"
import { rosreestrLayersGroups, rosreestrLayersSettings } from "../../mapFeatures/mapFunctions/rosreestrFunctions/rosreestrFunctions"

export default function RosreestrObjectsGroupsListItem({ groupId, selectedRosreestrObjectsByCategoryId }: any) {
    const navigate = useNavigate()
    const groupName = rosreestrLayersGroups[groupId]
    let subcategories: any = []
    Object.entries(selectedRosreestrObjectsByCategoryId).map(([categoryId, selectedRosreestrObjectsBySubcategoryId]: any) => {
        Object.entries(selectedRosreestrObjectsBySubcategoryId).map(([subcategoryId, rosreestrObjects]: any) => {
            const subcategoryNameFilter = (layerSettings: any) => layerSettings.objectsCategoryId == categoryId && layerSettings.objectsSubcategoryId == subcategoryId
            const rosreestrLayerSettings: any = Object.values(rosreestrLayersSettings).find((layerSettings: any) => subcategoryNameFilter(layerSettings))
            const name = rosreestrLayerSettings?.caption
            const amount = rosreestrObjects?.length
            if (amount === 1) {
                const objectId = rosreestrObjects[0]?.objectId
                subcategories.push({ name, amount, subcategoryId, categoryId, objectId })
            } else {
                subcategories.push({ name, amount, subcategoryId, categoryId })
            }
        })
    })

    function goToRosreestrObjectsList({ subcategoryId, categoryId }: any) {
        navigate(`/app/rosreestrObjects/${categoryId}/${subcategoryId}`)
    }

    function goToRosreestrObjectCard({ subcategoryId, categoryId, objectId }: any) {
        navigate(`/app/rosreestrObjects/${categoryId}/${subcategoryId}/${objectId}`)
    }

    function handleGoToRosreestrObjectsButtonClick({ subcategoryId, categoryId, objectId, amount }: any) {
        if (amount === 1) {
            goToRosreestrObjectCard({ subcategoryId, categoryId, objectId })
        } else {
            goToRosreestrObjectsList({ subcategoryId, categoryId })
        }
    }

    return (
        <div className="rosreestr-objects-group-list-item">
            <span className="rosreestr-objects-group-name">{groupName}:</span>
            {subcategories.map(({ name, amount, subcategoryId, categoryId, objectId }: any) =>
                <div className="rosreestr-objects-subcategory">
                    <span className="rosreestr-objects-subcategory-name">{name}: {amount}</span>
                    <button className="go-to-rosreestr-objects-button" onClick={() => handleGoToRosreestrObjectsButtonClick({ subcategoryId, categoryId, objectId, amount })}>Посмотреть</button>
                </div>
            )}
        </div>
    )
}
